import { SELECTED_LOCALE, DEFAULT_LOCALE } from "constants/index";
import {
    EXPORT_LANGUAGE_ID,
    LANGUAGE_CODE,
    LANGUAGE_JAPANESE_ID,
    LANGUAGE_SHORT_CODE,
    LANGUAGE_THAI_ID
} from "constants/language";

/**
 * get Accept Language
 *
 * @param {*} selectedLanguage
 */
export function getAcceptLanguage(selectedLanguage = 0) {
    const selectedLocale = localStorage.getItem(SELECTED_LOCALE);
    let acceptLanguage = LANGUAGE_SHORT_CODE[LANGUAGE_CODE.JAPANESE];
    // neu man hinh co select language => uu tien
    if (selectedLanguage !== 0) {
        switch (selectedLanguage) {
            case LANGUAGE_JAPANESE_ID:
                acceptLanguage = LANGUAGE_SHORT_CODE[LANGUAGE_CODE.JAPANESE];
                break;
            case LANGUAGE_THAI_ID:
                acceptLanguage = LANGUAGE_SHORT_CODE[LANGUAGE_CODE.THAI];
                break;
            default:
                acceptLanguage = LANGUAGE_SHORT_CODE[LANGUAGE_CODE.ENGLISH];
        }
    } else {
        if (!selectedLocale) {
            acceptLanguage = LANGUAGE_SHORT_CODE[LANGUAGE_CODE.ENGLISH];
        } else {
            const isKeyExist = selectedLocale in LANGUAGE_SHORT_CODE;
            if (isKeyExist) {
                acceptLanguage = LANGUAGE_SHORT_CODE[selectedLocale];
            } else {
                acceptLanguage = LANGUAGE_SHORT_CODE[LANGUAGE_CODE.JAPANESE];
            }
        }
    }
    return acceptLanguage;
}

/**
 *
 * @param {*} localeMsg
 * @param {*} locale
 * @returns
 */
export function getLocaleData(localeMsg, locale = "") {
    const selectedLocale =
        typeof locale !== "undefined" && locale.trim() !== ""
            ? locale
            : localStorage.getItem(SELECTED_LOCALE);
    const currentLocale = selectedLocale ? selectedLocale : DEFAULT_LOCALE;

    const isKeyExist = currentLocale in LANGUAGE_SHORT_CODE;
    if (isKeyExist) {
        return {
            [currentLocale]: localeMsg[currentLocale]
        };
    }

    return {
        [LANGUAGE_CODE.ENGLISH]: localeMsg[LANGUAGE_CODE.ENGLISH]
    };
}

/**
 *
 * @param {*} localeProviderList
 * @returns
 */
export function getCurrentLocaleProvider(localeProviderList) {
    const selectedLocale = localStorage.getItem(SELECTED_LOCALE);
    let currentLocale = selectedLocale ? selectedLocale : DEFAULT_LOCALE;

    const isKeyExist = currentLocale in LANGUAGE_SHORT_CODE;
    if (isKeyExist) {
        return localeProviderList[currentLocale];
    }

    return localeProviderList[LANGUAGE_CODE.ENGLISH];
}

/**
 *
 * @returns
 */
export function getCurrentExportLanguageId() {
    const selectedLocale = localStorage.getItem(SELECTED_LOCALE);
    let currentLocale = selectedLocale ? selectedLocale : DEFAULT_LOCALE;

    const isKeyExist = currentLocale in EXPORT_LANGUAGE_ID;
    if (isKeyExist) {
        return EXPORT_LANGUAGE_ID[currentLocale];
    }

    return EXPORT_LANGUAGE_ID[LANGUAGE_CODE.JAPANESE];
}
